var btnCustomizer = document.getElementById("zakeke-product-button");
var zakekeGuest = localStorage.getItem("zakekeGuest");
var zakekeCustomer = localStorage.getItem("zakekeCustomer");

var endTexts =  document.querySelectorAll(".order-summary__body > tr > td.text-subdued.text-end");
var lineItemInfo = document.querySelectorAll(".order-summary__body > tr > td .line-item__info > .v-stack > div");
var totalTexts = document.querySelectorAll(".cart-form__totals > .h-stack > span:last-child");
var pricingSuggestion = document.querySelectorAll(".cart .pricing-suggestion");
var quantityInput = document.querySelectorAll(".cart .quantity-input");
var cartLinks = document.querySelectorAll(".cart .link, #cart-drawer .link");
var buttonCheckout = document.querySelector(".cart button[name='checkout']");
var cartEl = document.querySelector(".cart");
var headerEl = document.querySelector("header");

// function formSubmited(){
//     let form = document.querySelector("form.cart-form");

//     if(!form){
//       form = document.querySelector("form.buy-buttons");
//     }
  
//     function handleFormSubmit(e) {
//       e.preventDefault();
  
//       fetch(`${Shopify.routes.root}cart.json`).then(res => res.json()).then(cart => {
//          if(cart?.items?.length > 0){
//           fetch("https://merchly-app.papertiger.io/proxy/cartCalculation",{
//             method:"POST",
//             body:JSON.stringify(cart.items),
//             headers:{"Content-Type":"application/json"}
//           }).then(res => res.json()).then(async items => {
//               form.removeEventListener("submit", preventDefaultHandler);
//               window.location.href = "/checkout";
            
//           })
           
//          }   
//       })
//     }
  
//     function preventDefaultHandler(e) {
//       e.preventDefault();
//     }
  
//     form.addEventListener("submit", handleFormSubmit);
  
//     const originalAddEventListener = form.addEventListener;
//     const originalRemoveEventListener = form.removeEventListener;
  
//     form.addEventListener = function(type, listener, options) {
//       if (type === 'submit' && listener === handleFormSubmit) {
//         originalAddEventListener.call(form, type, listener, options);
//       } else if (type !== 'submit') {
//         originalAddEventListener.call(form, type, listener, options);
//       }
//     };
  
//     form.removeEventListener = function(type, listener, options) {
//       if (type === 'submit' && listener === handleFormSubmit) {
//         console.warn("Attempt to remove protected listener blocked.");
//       } else {
//         originalRemoveEventListener.call(form, type, listener, options);
//       }
//     };
  
//     form.addEventListener("submit", preventDefaultHandler);
  
//     const observer = new MutationObserver((mutations) => {
//       mutations.forEach((mutation) => {
//         if (mutation.type === 'attributes' && mutation.attributeName === 'onsubmit') {
//           console.warn('Attempt to change onsubmit attribute blocked.');
//           form.onsubmit = null;
//         }
//       });
//     });
  
//     observer.observe(form, {
//       attributes: true,
//       attributeFilter: ['onsubmit']
//     });
    
//   }

if(btnCustomizer){  
  btnCustomizer.addEventListener("click", function (evt) {
    evt.preventDefault();
    var formCustomizer = document.getElementById("frmCustomizer");
    var formProductPage = document.querySelector("form.shopify-product-form")
    formCustomizer.elements["quantity"].value = 1;
    formCustomizer.elements["id"].value = formProductPage.elements["id"].value;
    formCustomizer.elements["zakekeGuest"].value = zakekeGuest;
    formCustomizer.elements["zakekeCustomer"].value = zakekeCustomer;
    formCustomizer.submit();
  });
}

async function updateCart(changeSizeData = null) {
  if (window.themeVariables.settings.pageType === "cart") {
      document.querySelectorAll(".order-summary__body > tr > td.text-subdued.text-end")?.forEach(function(el){ el.innerHTML = "calculating..." });
      document.querySelectorAll(".order-summary__body > tr > td .line-item__info > .v-stack > div")?.forEach(function(el){ el.innerHTML = "calculating..." });
      document.querySelectorAll(".cart-form__totals > .h-stack > span:last-child")?.forEach(function(el){ el.innerHTML = "calculating..." })
      document.querySelectorAll(".cart .link, #cart-drawer .link")?.forEach(function(el){
          el.classList.add("disabled");
        });
      document.querySelectorAll(".cart .pricing-suggestion")?.forEach(function(el){ el.remove() });
      document.querySelectorAll(".cart .quantity-input")?.forEach(function(el){
        el.setAttribute("disabled", "");
      });
      document.querySelector(".cart button[name='checkout']")?.setAttribute("disabled", "");
      document.querySelectorAll(".cart line-item .line-item-size-picker[data-cart-item-calculated]").forEach((el) => { 
        el?.querySelector('button.select').setAttribute("disabled", "");
        el?.querySelector('button>span').classList.add("hidden");

        const sizePickerLoader = el?.querySelector('button>pill-loader');

        if(sizePickerLoader) {
          sizePickerLoader.style.visibility = "visible";
          sizePickerLoader.classList.remove("hidden");
        }
      })
  
      var index = 0;

      await fetch(`${Shopify.routes.root}cart.json`).then(res => res.json()).then(async (cart) => {
         if(cart?.items?.length > 0){

          // fix buy again on account page
          let missingPropertiesItems = cart.items.filter(item => !item.properties._designID);
  
          if (missingPropertiesItems.length > 0) {
            const updatedItems = await Promise.all(missingPropertiesItems.map(async (item) => {

              if (!item.properties._designID) {
                const response = await fetch("https://merchly-app.papertiger.io/proxy/getProductDesign", {
                  method: "POST",
                  body: JSON.stringify({
                    designProductId: item.product_id,
                    quantity: item.quantity
                  }),
                  headers: { "Content-Type": "application/json" }
                });
          
                const data = await response.json();
          
                return {
                  ...item,
                  properties: {
                    "_designID": data.design.id,
                    "_productID": data.id,
                    "_modificationID": data.design.modificationId,
                    "_productTitle": data.title,
                    "_productUrl": data.handle,
                    "_originalPrice": data.design.originalPrice
                  }
                };
              }
          
              return item;
            }));
            missingPropertiesItems = updatedItems;
          }

          if(changeSizeData) {
            const changedProductID = changeSizeData.product.id;
            const changedVariant = changeSizeData.product?.variants[0];
            const changedVariantID = changedVariant?.id;
            const changedOriginalPrice = changeSizeData._originalPrice;

            cart.items = cart.items.map(item => {
              if (item.product_id === changedProductID && item.variant_id === changedVariantID) {
                return {
                  ...item,
                  properties: {
                    ...item.properties,
                    _originalPrice: changedOriginalPrice
                  }
                };
              }
              return item;
            });
          }
           
          await fetch("https://merchly-app.papertiger.io/proxy/cartCalculation",{
            method:"POST",
            body:JSON.stringify(missingPropertiesItems.length ? missingPropertiesItems : cart.items),
            headers:{"Content-Type":"application/json"}
          }).then(res => res.json()).then(async items => {
            for (const item of items) {
              await fetch(`${Shopify.routes.root}cart/change.js`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify(item)
             }).then(res => res.json()).then(async res => {
                if(index == items.length - 1){
                   await fetch(`${Shopify.routes.root}cart`).then(res => res.text()).then( async (htmlString) => {
                      const parser = new DOMParser();
                      const html = parser.parseFromString(htmlString, 'text/html');
                      document.querySelector(".cart").outerHTML = html.querySelector(".cart").outerHTML;
                      document.querySelector("header").outerHTML = html.querySelector("header").outerHTML;
                      document.querySelector(".cart button[name='checkout']").removeAttribute("disabled");
                  })
                }
             });
  
              index++;
            }
          })
           
         }   
      })

      //init size picker
      await initSizePicker();
  }
}

updateCart();

async function handleSizeChange(event, data) {
  let payload = data;
  payload.selectedSize = event.detail.value;

  const {currentProductId, currentVariantId} = payload;

  document.querySelectorAll(".order-summary__body > tr > td.text-subdued.text-end")?.forEach(function(el){ el.innerHTML = "calculating..." });
  document.querySelectorAll(".order-summary__body > tr > td .line-item__info > .v-stack > div")?.forEach(function(el){ el.innerHTML = "calculating..." });
  document.querySelectorAll(".cart-form__totals > .h-stack > span:last-child")?.forEach(function(el){ el.innerHTML = "calculating..." })
  document.querySelectorAll(".cart .link, #cart-drawer .link")?.forEach(function(el){
      el.classList.add("disabled");
    });
  document.querySelectorAll(".cart .pricing-suggestion")?.forEach(function(el){ el.remove() });
  document.querySelectorAll(".cart .quantity-input")?.forEach(function(el){
    el.setAttribute("disabled", "");
  });
  document.querySelector(".cart button[name='checkout']")?.setAttribute("disabled", "");
  document.querySelectorAll(".cart line-item .line-item-size-picker[data-cart-item-calculated]").forEach((el) => { 
    el?.querySelector('button.select')?.setAttribute("disabled", "") 
  })

  const sizePickerElemet = document.querySelector(`.cart .cart-order .line-item-size-picker:not(.no-editable)[data-product-id="${currentProductId}"][data-variant-id="${currentVariantId}"]`);
  const sizePickerSelectedSize = sizePickerElemet.querySelector('button>span');

  // show loader
  const loader = sizePickerElemet.querySelector(`button>pill-loader`);

  sizePickerSelectedSize.classList.add("hidden");
  loader.classList.remove("hidden");
  loader.style.visibility = "visible";

  fetch("https://merchly-app.papertiger.io/proxy/changeSize", {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json"
    }
  }).then((res) => res.json()).then(async (data) => {
    if (data.product) {
      await updateCart(data);

      const sizePickerElemet = document.querySelector(`.cart .cart-order .line-item-size-picker[data-product-id="${currentProductId}"][data-variant-id="${currentVariantId}"]`);
      const sizePickerSelectedSize = sizePickerElemet.querySelector('button>span');
      const sizePickerItems = sizePickerElemet.querySelectorAll('x-listbox .popover-listbox__option');

      sizePickerSelectedSize.innerText = payload.selectedSize;

      // make all dropdown options unselected
      sizePickerItems.forEach(item => item.setAttribute('aria-selected', 'false'))

      sizePickerItems.forEach((button) => {
        if(button.value === payload.selectedSize) {
          button.setAttribute('aria-selected', 'true')
        }
      })
    }
  })
}

async function initSizePicker() {
  const lineItemSizePickers = document.querySelectorAll(
    ".cart line-item .line-item-size-picker[data-cart-item-calculated]"
  );

  for (const el of lineItemSizePickers) {
    el.setAttribute("data-cart-item-calculated", "true");

    const popoverId = el.getAttribute("data-id");
    const productId = el.getAttribute("data-product-id");
    const variantId = el.getAttribute("data-variant-id");
    const quantity = el.getAttribute("data-quantity");
    const selectedColor = el.getAttribute("data-selected-color");
    const selectedSize = el.getAttribute("data-selected-size");
    const noEditable = el.classList.contains("no-editable");

    const popover = el.querySelector(`x-popover#${popoverId}`);
    const listBox = popover.querySelector(`x-listbox`);
    const listBoxButton = listBox.querySelector(`button.popover-listbox__option`);

    // loader
    const sizePickerSelectedSize = el.querySelector(`button>span`);
    const loader = el.querySelector(`button>pill-loader`);

    sizePickerSelectedSize.classList.add("hidden");
    loader.classList.remove("hidden");
    loader.style.visibility = "visible";

    try {
      const getProduct = await fetch(
        "https://merchly-app.papertiger.io/proxy/getProductDesign",
        {
          method: "POST",
          body: JSON.stringify({
            designProductId: productId,
            quantity: quantity,
            fields: ["variants", "options"],
          }),
          headers: { "Content-Type": "application/json" },
        }
      );

      const { variants, options } = await getProduct.json();
      const sizes = variants
        ?.filter((v) => v.option1 === selectedColor)
        ?.map((s) => s.option2);

      if (sizes && sizes.length > 0) {
        const noEditableElement = listBoxButton.closest('.line-item-size-picker:is(.no-editable)')
        
        sizes.forEach((size, index) => {
          const newButton = listBoxButton.cloneNode(true);

          newButton.textContent = size;
          newButton.setAttribute("value", size);
          newButton.setAttribute("id", `${popoverId}-${size}`);
          if(selectedSize === size && !noEditableElement) {
            newButton.setAttribute("aria-selected", "true");
          } else {
            newButton.setAttribute("aria-selected", "false");
          }

          if(index === 0 && noEditableElement) {
            newButton.setAttribute("aria-selected", "true");
            noEditableElement.querySelector('button.select>span').textContent = size;
            noEditableElement.closest('.modal-overlay').setAttribute('data-selected-size', size);
          }

          newButton.addEventListener("click", function (event) {
            listBox.setAttribute("aria-activedescendant", event.currentTarget.id);

            // Dispatch custom event "listbox:select"
            event.currentTarget.dispatchEvent(
              new CustomEvent("listbox:select", {
                bubbles: true,
                detail: {
                  value: event.currentTarget.value,
                },
              })
            );
          });

          listBox.appendChild(newButton);
        });

        listBoxButton.remove();
      }

      const changeSizePayload = {
        currentProductId: productId,
        currentVariantId: variantId,
        currentQuantity: quantity,
        selectedColor: selectedColor,
      };
      
      popover.addEventListener("listbox:select", function (event) {
        if(!noEditable) {
          handleSizeChange(event, changeSizePayload);
        } else {
          event.target.closest('.modal-overlay').setAttribute('data-selected-size', event.target.value);
        }
      });
    } catch (error) {
      console.error(`Error fetching product ${productId}:`, error);
    }

    // remove loader
    sizePickerSelectedSize.classList.remove("hidden");
    loader.classList.add("hidden");
    loader.style.visibility = "hidden";

    async function submitAddSize(data) {
      const activeModal = document.querySelector('.modal-overlay.active');
      activeModal.querySelector('.submit-modal-btn').textContent = 'Adding...';
      activeModal.querySelector('.submit-modal-btn').setAttribute('disabled', 'disabled');
      
      fetch("https://merchly-app.papertiger.io/proxy/addAnotherSize", {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json"
        }
      }).then((res) => res.json()).then((dataRes) => {
        if (dataRes.product) {
          const product = dataRes.product;
          
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: dataRes.product.variants[0].id,
              quantity: data.newQuantity,
            })
          }).then((res) => res.json()).then( async (cartRes) => {
            await updateCart();
            
            if (activeModal) {
              activeModal.classList.remove('active');
            }

          });

        }
      })
    }
    
    function renderModal() {
      var openBtn = document.getElementById('openModalBtn');
      var closeBtn = document.getElementById('closeModalBtn');
      var overlay = document.getElementById('modalOverlay');

      const modalTriggers = document.querySelectorAll('.trigger-modal');

      modalTriggers.forEach(trigger => {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();

          const id = this.dataset.id;
          const modal = document.querySelector(`#modalOverlay-${id}`);
          if (modal) {
            modal.classList.add('active');
          }
        });
      });

      const modalOverlays = document.querySelectorAll('.modal-overlay');

      modalOverlays.forEach(overlay => {
        // Simpan handler di property DOM element supaya mudah dihapus
        if (overlay._overlayClickHandler) {
          overlay.removeEventListener('click', overlay._overlayClickHandler);
        }
        overlay._overlayClickHandler = function (e) {
          if (e.target === overlay) {
            overlay.classList.remove('active');
          }
        };
        overlay.addEventListener('click', overlay._overlayClickHandler);
      
        const closeBtns = overlay.querySelectorAll('.close-modal-btn');
        closeBtns.forEach(btn => {
          if (btn._closeClickHandler) {
            btn.removeEventListener('click', btn._closeClickHandler);
          }
          btn._closeClickHandler = function () {
            overlay.classList.remove('active');
          };
          btn.addEventListener('click', btn._closeClickHandler);
        });
      
        const quantityInputs = overlay.querySelectorAll('.quantity-input');
        quantityInputs.forEach(input => {
          if (input._quantityChangeHandler) {
            input.removeEventListener('change', input._quantityChangeHandler);
          }
          input._quantityChangeHandler = function (event) {
            const newQuantity = event.target.value;
            overlay.dataset.newQuantity = newQuantity;
            
            if (newQuantity > 0) {
              overlay.querySelector('.submit-modal-btn').removeAttribute('disabled');
            }
          };
          input.addEventListener('change', input._quantityChangeHandler);
        });
      
        const submitBtns = overlay.querySelectorAll('.submit-modal-btn');
        submitBtns.forEach(btn => {
          if (btn._submitClickHandler) {
            btn.removeEventListener('click', btn._submitClickHandler);
          }
          btn._submitClickHandler = function () {
            const productId = overlay.dataset.productId;
            const selectedColor = overlay.dataset.selectedColor;
            const selectedSize = overlay.dataset.selectedSize;
            const newQuantity = parseInt(overlay.dataset.newQuantity);
            const latestQuantity = parseInt(overlay.dataset.latestQuantity);

            const data = {
              productId,
              selectedColor,
              selectedSize,
              newQuantity, 
              latestQuantity
            }

            submitAddSize(data)
          };
          btn.addEventListener('click', btn._submitClickHandler);
        });
      });
      
    }

    renderModal();
  }
}
